import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

const Login = ({ onAuth }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const { data } = await api.post("/auth/login", { email, password }); onAuth(data); }
    catch (er) { setErr(apiError(er)); }
    setBusy(false);
  };
  const inp = "w-full h-12 bg-transparent border-b border-white/20 focus:border-[#1bb4f2] outline-none";
  return (
    <div className="min-h-screen grid place-items-center px-5 bg-[#07080B] text-white">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <img src="/velocity-badge.png" alt="Velocity Detailing" className="h-24 mx-auto" />
        <h1 className="mt-8 font-display font-black uppercase text-3xl text-center">Staff login</h1>
        <div className="mt-10 space-y-6">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inp} data-testid="admin-login-email" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inp} data-testid="admin-login-input" />
        </div>
        {err && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} data-testid="admin-login-button" className="mt-8 w-full h-12 inline-flex items-center justify-center gap-2 bg-[#1bb4f2] text-[#07080B] font-semibold hover:bg-white transition-colors disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Sign in
        </button>
        <Link to="/" className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="admin-back-home"><ArrowLeft className="h-4 w-4" />Back to site</Link>
      </form>
    </div>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#07080B]"><Loader2 className="h-6 w-6 animate-spin text-[#1bb4f2]" /></div>;
  if (!user) return <Login onAuth={setUser} />;
  return <AdminDashboard user={user} onLogout={() => setUser(false)} />;
}
